<div class="modal-content">
  <div class="modal-header" #handle>
    <h1 class="title" translate="captureTransaction.submitModal.title"></h1>
  </div>
  <div class="modal-body">
    <p translate="captureTransaction.submitModal.description"></p>
  </div>
  <div class="modal-footer">
    <div class="is-flex">
      <button type="button" class="mr-1" (click)="close()" fino-button>Zurück</button>
      <button
        [primary]="true"
        type="button"
        class="ml-1"
        (click)="submit()"
        fino-button
        translate="captureTransaction.submitModal.submit"
      ></button>
    </div>
  </div>
</div>
